import { action } from '@ember/object';
import Component from '@glimmer/component';

import $ from 'jquery';

// https://zapier.com/developer/documentation/v2/shared-zaps/#embed-widget-features
import didInsert from 'webapp/modifiers/did-insert';
import BarLoaderComponent from 'webapp/components/bar-loader';

export default class ZapsListComponent extends Component {
	@action
	fetchZaps() {
		// $.getScript('https://zapier.com/zapbook/embed/widget.js?services=databox&container=true&limit=100&html_id=zaps');
		$.getScript(
			'https://zapier.com/zapbook/embed/widget.js?container=true&guided_zaps=14556,14541,14360,14545,14550,14547,14546,14544,14553,14548,14551,14552&html_id=zaps',
		);

		window.zapierOpenDialog = function (e: Event) {
			e.preventDefault();
			e.stopPropagation();
			const button = e.target as HTMLElement;
			window.open(
				button.getAttribute('data-popup-href') || '',
				'zapierModalWindow',
				'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=980,height=700',
			);
			return false;
		};
	}
	<template>
		<div id="zaps" {{didInsert this.fetchZaps}}>
			<BarLoaderComponent />
		</div>
	</template>
}
